import styled, { keyframes } from 'styled-components';

interface propsContainer {
  open: boolean;
  isFirstLevel: boolean;
}

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-100%);
    opacity: 0;
  }
`;

const slideIn = keyframes`
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const Main = styled.div`
  display: flex;
  justify-content: center;
  background-color: ${({ theme }) => theme.COLORS.BACKGROUND_SECONDARY};
`;

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background: ${({ theme }) => theme.COLORS.BACKGROUND_PRIMARY};
  transition: padding-left 0.5s;
  overflow: hidden;
  /* Calcula a largura máxima baseada na altura da tela mantendo a proporção do Figma (1440 x 650) */
  max-width: calc(100vh * (1440 / 650));
  /* Garante que não ultrapasse 1440px em telas muito altas */
  max-width: min(calc(100vh * (1440 / 650)), 1440px);
  /* Garante que não seja menor que 320px em telas muito pequenas */
  min-width: 320px;
  position: relative;
  //border-right: 1px solid ${({ theme }) => theme.COLORS.PRIMARY};
  //border-left: 1px solid ${({ theme }) => theme.COLORS.PRIMARY};
`;

export const Box = styled.div`
  display: flex;
  flex-direction: row;
`;

export const NewsContainer = styled.div`
  display: flex;
  margin-left: 9rem;
`;

export const AnimatedWrapper = styled.div<{ isVisible: boolean }>`
  animation: ${({ isVisible }) => (isVisible ? slideIn : slideOut)} 0.3s forwards;
  position: relative;
  width: ${({ isVisible }) => (isVisible ? '25rem' : '0')};
  overflow: hidden;
  margin-left: 9.1rem;
`;

export const UserCardContainer = styled.div`
  width: 20rem;
  display: flex;
  justify-content: start;
  align-items: start;
  margin-left: 9rem;
  height: 100%;
`;

export const Wrapper = styled.div<propsContainer>`
  width: 100%;
  overflow-y: auto;
  height: calc(100% - 56px);
  padding-left: ${({ open, isFirstLevel }) => (open ? (isFirstLevel ? '9rem' : '18rem') : '0px')};
  padding-top: 8px;
  padding-bottom: 16px;
  background: ${({ theme }) => theme.COLORS.BACKGROUND_PRIMARY};
  display: flex;
  justify-content: center;
  position: relative;
  transition: padding-left 0.3s;
`;

export const WrapperMobile = styled.div<propsContainer>`
  width: 100%;
  overflow: auto;
  height: calc(100% - 56px);
  padding-top: 64px;
  padding-bottom: 16px;
  background: ${({ theme }) => theme.COLORS.BACKGROUND_PRIMARY};
  display: flex;
  justify-content: center;
  position: relative;
  transition: padding-left 0.3s;
  padding: 1rem 0.5rem;
`;

export const Content = styled.div`
  display: flex;
  width: 100%;
  height: max-content;
  background: ${({ theme }) => theme.COLORS.BACKGROUND_PRIMARY};
  padding-left: 1.5rem;
  padding-right: 1.5rem;
`;

export const ContentMobile = styled.div<{ isCommunity: boolean }>`
  display: flex;
  width: 100%;
  height: ${({ isCommunity }) => (isCommunity ? '100%' : 'max-content')};
  background: ${({ theme }) => theme.COLORS.BACKGROUND_SECONDARY};
  padding: 0.5rem;
  padding-bottom: 2rem;
`;

export const IconButtonContainer = styled.div`
  position: absolute;
  top: 0.2rem;
  left: 0.5rem;
  z-index: 10;
  margin-top: 5rem;
  margin-left: 8.5rem;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;
